import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppRouting } from '@app/app.routing';
import { CoreModule } from '@core/core.module';
import { AppComponent } from './app.component';
import { PortalModule } from '@angular/cdk/portal';
import { SharedModule } from '@shared/shared.module';
import { DummyPageComponent } from '@app/pages/dummy-page/dummy-page.component';
import { PageNotFoundComponent } from '@app/pages/error-pages/page-not-found.component';
import { NotLoggedInPageComponent } from '@app/pages/error-pages/not-logged-in-page.component';
import { ServerNotReachableComponent } from '@app/pages/error-pages/server-not-reachable.component';
import { ContactModule } from '@core/components/contact/contact.module';
import { MapModule } from '@core/components/map/map.module';
import { TranslationModule } from '@core/modules/translation/translation.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats
} from '@angular/material/core';
import { API_STORAGE_PREFIX } from '@core/services/storage.service';
import { environment } from '@env/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { TippyModule } from '@ngneat/helipopper';
import { DialogModule } from '@ngneat/dialog';
import { EffectsModule } from '@shared/modules/effects/effects.module';
import { ConnectionEffect } from '@core/effects/connection.effect';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { HotToastModule } from '@ngneat/hot-toast';
import { DateFnsAdapter, MatDateFnsModule } from '@angular/material-date-fns-adapter';
import { de } from 'date-fns/locale';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);
registerLocaleData(localeDe, 'DE', localeDeExtra);

export const DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'dd.MM.yyyy'
  },
  display: {
    dateInput: 'dd.MM.yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy'
  }
};

@NgModule({
  declarations: [
    AppComponent,
    DummyPageComponent,
    PageNotFoundComponent,
    NotLoggedInPageComponent,
    ServerNotReachableComponent
  ],
  imports: [
    // Angular
    CommonModule,
    BrowserAnimationsModule,
    RouterModule,
    PortalModule,

    // Internal
    ...CoreModule.forRoot(),
    SharedModule,
    AppRouting,
    EffectsModule.register([ConnectionEffect]),
    TranslationModule,

    ContactModule,
    MapModule,

    // External
    TippyModule.forRoot(),
    DialogModule.forRoot(),
    HotToastModule.forRoot({
      position: 'top-right',
      theme: 'snackbar'
    }),

    // Angular Material
    MatDateFnsModule,
    MatTooltipModule,
    MatBadgeModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule
  ],
  exports: [],
  providers: [
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: MAT_DATE_LOCALE, useValue: de },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
    {
      provide: DateAdapter,
      useClass: DateFnsAdapter
    },
    {
      provide: API_STORAGE_PREFIX,
      useValue: environment.apiStoragePrefix
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: {
        formFieldAppearance: 'fill'
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
